<div class=" contact-us app-primary-bg">
    <div class=" pt-100">
        <div class="text-center">
            <h1 class="fs-36">Pre Register</h1>
            <!-- <p>We love to hear from you!</p> -->
        </div>
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div fxFlex="80%" class="cont-box mlr-10">
                <div fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="start start" fxLayout.xs="column">
                    <form [formGroup]="registerForm" autocomplete="off" fxLayout.xs="column">
                        <div fxFlex="60%" fxFlex.md="50" fxFlex.xs="100%">
                            <div fxLayout="row wrap" class="profile_basic" fxFlex="100%" fxLayoutGap="35px"
                                fxLayoutGap.xs="0px" fxLayoutAlign="start center">
                                <div fxFlex="100%" fxFlex.xs="100%" class="pb-20">
                                    <h1>Submit your details</h1>
                                </div>
                                <div fxFlex="42%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="pb-5 mb-1">
                                    <mat-form-field class="w-100 ">
                                        <mat-label>Your Name</mat-label>
                                        <input matInput formControlName="name" required maxlength="35" allowValues
                                            isInputType="onlyChar">
                                        <mat-error *ngIf="registerForm.get('name').hasError('required')">
                                            Please enter your name
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="45%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%"
                                    class="pb-5 mb-1 phone-number-placeholder">
                                    <span class="placeholder-label">Phone
                                        <span
                                            [ngClass]="{'placeholder-label-required' : (registerForm.get('phone').hasError('required') && businessPhoneValue.touched) }">*</span>
                                    </span>
                                    <mat-form-field class="w-100 country-flag-txt">
                                        <input matInput countryFlagPhone allowValues isInputType="phone"
                                             formControlName="phone" required>
                                        <mat-error *ngIf="registerForm.get('phone').hasError('required')">
                                            Please enter phone number
                                        </mat-error>
                                        <mat-error *ngIf="!registerForm.get('phone').hasError('required') && 
                                        registerForm.get('phone').hasError('isInvalid')">
                                            Please enter valid phone number
                                        </mat-error>
                                        <!-- <input matInput hidden="true" />
                                        <ngx-intl-tel-input [cssClass]="'custom'"
                                            [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false"
                                            [enablePlaceholder]="true" [searchCountryFlag]="true"
                                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                            [selectFirstCountry]="true" [selectedCountryISO]="selectedCountry"
                                            [maxLength]="15" [phoneValidation]="true"
                                            [separateDialCode]="separateDialCode" name="phone" formControlName="phone">
                                        </ngx-intl-tel-input>
                                        <mat-hint
                                            *ngIf="registerForm.get('phone').hasError('required') && businessPhoneValue.touched">
                                            Please enter phone number
                                        </mat-hint>
                                        <mat-hint
                                            *ngIf="!registerForm.get('phone').hasError('required') && 
                            (businessPhoneValue.invalid || (businessPhoneValue.touched && businessPhoneValue.invalid))">
                                            Please enter valid phone number
                                        </mat-hint> -->
                                    </mat-form-field>
                                </div>
                                <div fxFlex="100%" fxFlex.xs="100%" class="pb-5 mb-1">
                                    <mat-form-field class="w-100 ">
                                        <mat-label>Email</mat-label>
                                        <input matInput formControlName="email" required maxlength="255">
                                        <mat-error *ngIf="registerForm.get('email').hasError('required')">
                                            Please enter email
                                        </mat-error>
                                        <mat-error
                                            *ngIf="registerForm.get('email').hasError('email') || registerForm.get('email').hasError('pattern')">
                                            Please enter valid email
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="100%" fxFlex.xs="100%" class="pb-5 pt-10">
                                    <mat-form-field class="w-100">
                                        <mat-label>Organization Name</mat-label>
                                        <input matInput formControlName="organization_name" allowValues
                                            isInputType="alphaNumeric">
                                    </mat-form-field>
                                </div>
                                <!-- <div fxFlex="100%" fxFlex.xs="100%" class="pb-5 mb-1">
                                    <mat-form-field class="w-100 ">
                                        <mat-label>Leave a message</mat-label>
                                        <textarea matInput rows="4" formControlName="message"
                                            required></textarea>
                                        <mat-error *ngIf="registerForm.get('message').hasError('required')">
                                            Please Leave a message
                                        </mat-error>
                                    </mat-form-field>
                                </div> -->
                                <div fxFlex="100%" fxFlex.xs="100%" class="mb-40 mt-3">
                                    <button mat-flat-button color="primary" class="flat-secondary-button primary-bg-btn1"
                                        (click)="onSubmit()">Submit</button>

                                </div>
                            </div>

                        </div>

                        <div fxFlex="40%" fxFlex.md="50" fxFlex.xs="100%" class="pl-85">
                            <div fxFlex="100%" fxFlex.xs="100%">
                                <h1 class="pb-20">Contact Information</h1>
                                <p class="fs-16 fw-500">{{clientDetails.name}} Inc.</p>
                                <p><i class="fa fa-envelope cont-icon" aria-hidden="true"></i>
                                    Email: <span>support&#64;arevea.com</span></p>
                                <!-- 
                                <p><i class="fa fa-map-marker cont-icon" aria-hidden="true"></i>385 Moffett Park Drive, Suite 105,<br>Sunnyvale, CA 94089<br>
                                    <br>
                                    <i class="fa fa-phone cont-icon" aria-hidden="true"></i> Phone: 408 475 5906<br><br>
                                    <i class="fa fa-envelope cont-icon" aria-hidden="true"></i>Email: <span style="color:#fff;">arun@arevea.com</span></p>
                                    <p class="pt-20 fs-16 fw-500">{{clientDetails.name}} UK Ltd</p>
                                <p><i class="fa fa-map-marker cont-icon" aria-hidden="true"></i>291 Bounces Road, London N9 8LP<br>
                                    <br>
                                    <i class="fa fa-phone cont-icon" aria-hidden="true"></i> Phone: 07425588260<br><br>
                                    <i class="fa fa-envelope cont-icon" aria-hidden="true"></i>Email: <span style="color:#fff;">zay.powell@arevea.com</span></p> -->
                                <!-- <p><i class="fa fa-map-marker cont-icon" aria-hidden="true"></i>3031 Tisch
                                    Way, 110 Plaza West,<br>
                                    San Jose, CA 95128<br><br>
                                    <i class="fa fa-phone cont-icon" aria-hidden="true"></i> Phone: +1 (669)
                                    247-6699<br><br>
                                    <i class="fa fa-envelope cont-icon" aria-hidden="true"></i>email: abc@xyz.com</p> -->
                                <div class="Fsocial mt-2">
                                    <!-- <a matTooltipPosition="above" matTooltip="Facebook"
                                        href="https://www.facebook.com/Areveatv-111754950520279/" target="_blank">
                                        <i class="fa fa-facebook-f"></i>
                                    </a> -->
                                    <!-- <a href=""><i class="fa fa-facebook-f"></i></a> -->
                                    <!-- <a matTooltipPosition="above" matTooltip="Twitter"
                                        href="https://twitter.com/areveatv" target="_blank">
                                        <i class="fa fa-twitter"></i>
                                    </a> -->
                                    <!-- <a href=""><i class="fa fa-twitter"></i></a> -->
                                    <!-- <a matTooltipPosition="above" matTooltip="Instagram"
                                        href="https://www.instagram.com/areveatv/" target="_blank">
                                        <i class="fa fa-instagram"></i>
                                    </a> -->
                                    <!-- <a href=""><i class="fa fa-linkedin"></i></a> -->
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>


    </div>
</div>